"use client";

import Link from "next/link";

import type { TopBountiesDiscovered } from "@/backend/focus";
import XAvatar from "@/components/shared/x-avatar";
import { getUserName } from "@/utils/usernames";

type TopTableProfileAvatarProps = {
  topBounty: TopBountiesDiscovered;
};

const TopTableProfileAvatar = ({ topBounty }: TopTableProfileAvatarProps) => {
  if (!topBounty) {
    return null;
  }

  return (
    <Link
      href={`/bounty/${topBounty.TwitterUsername}`}
      className="
        flex shrink-0 items-center gap-2 text-xs
        md:text-sm
      "
    >
      <XAvatar
        src={topBounty.TwitterProfileImageUrl}
        alt={topBounty.TwitterUsername}
        width={26}
        height={26}
        className="shrink-0 rounded-full border border-border"
      />
      <span
        className="
          truncate overflow-hidden
          hover:underline hover:underline-offset-4
        "
      >
        {getUserName({
          account: {
            username: topBounty.TwitterUsername,
          },
        })}
      </span>
    </Link>
  );
};

export default TopTableProfileAvatar;
